// extracted by mini-css-extract-plugin
export default {"wrapper":"two-fa-changed_wrapper__Qtr++","opacity-transition":"two-fa-changed_opacity-transition__W8-aK"};